import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.promise.finally";
import "regenerator-runtime/runtime";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import iconsMixin from '../dtwin/state/bridge/iconsMixin';
import { get, debounce } from 'lodash';
export default {
  name: 'DeviceTemplateAddWizard',
  mixins: [iconsMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    return {
      accounts: [],
      formValid: false,
      deviceDriversLoading: false,
      createServerRequest: false,
      template: {},
      accountName: '',
      deviceTemplatesTotalCount: 0,
      deviceTemplatesLimit: 0,
      deviceTemplateLimitExceeded: false,
      requiredRule: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }],
      selectedBridge: null,
      deviceBridgesForAccount: [],
      bridgeTypes: [],
      deviceBridgesLoading: false,
      deviceDriversData: {
        deviceDrivers: [],
        driverSearch: null,
        searchTerm: null,
        currentPage: 0,
        driversHasNextPage: true
      }
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])),
  watch: {
    'template.tenantId': function templateTenantId() {
      this.fetchTenantById();
      this.fetchParents();
      this.fetchNextDrivers();
      this.fetchBridges();
    },
    'deviceDriversData.driverSearch': debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newValue, oldValue) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(newValue === oldValue)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.deviceDriversData = {
                  deviceDrivers: [],
                  driverSearch: newValue,
                  searchTerm: newValue,
                  currentPage: 0,
                  driversHasNextPage: true
                };
                _context.next = 5;
                return this.fetchNextDrivers();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), 200)
  },
  created: function created() {
    this.fetchAccounts();
  },
  methods: {
    closeDialog: function closeDialog() {
      this.template = {};
      this.$emit('close');
    },
    fetchAccounts: function fetchAccounts() {
      var _this2 = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this2.accounts = accounts.filter(function (t) {
          return !t.isRootTenant;
        });
      }).catch(function (error) {
        console.error(error);

        _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    },
    fetchParents: function fetchParents() {
      var _this3 = this;

      ApiService.digitalTwinFetchChildren(this, null, 0, 1, null, ['bare'], false, this.template.tenantId).then(function (result) {
        _this3.template.parentId = get(result, 'digitaltwins[0].id', null);
      }).catch(function (error) {
        console.error('Error fetching parents', error);
      });
    },
    save: function save() {
      var _this4 = this;

      this.createServerRequest = true;
      this.template.deviceDriverVersion = 'default';
      this.template.connectorId = this.selectedBridge.id;
      ApiService.deviceTemplateCreate(this.template).then(function (res) {
        _this4.$emit('created', res);

        _this4.$snack(_this4.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.createSuccess'), 'success');
      }).catch(function (error) {
        if (error.response && _this4.$i18n_te("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.createError'), 'error');
        }
      }).finally(function () {
        _this4.createServerRequest = false;
        _this4.template = {};
      });
    },
    parentSelectorFilter: function parentSelectorFilter(item) {
      return item.tenantId === this.template.tenantId;
    },
    endDriversIntersect: function () {
      var _endDriversIntersect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(entries, observer, isIntersecting) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!isIntersecting) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.fetchNextDrivers();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function endDriversIntersect(_x3, _x4, _x5) {
        return _endDriversIntersect.apply(this, arguments);
      }

      return endDriversIntersect;
    }(),
    fetchNextDrivers: function () {
      var _fetchNextDrivers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var DRIVER_PAGE_SIZE, moreDrivers;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this.deviceDriversData.driversHasNextPage || this.deviceDriversData.isLoading)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.prev = 2;
                DRIVER_PAGE_SIZE = 10;
                this.deviceDriversData.isLoading = true;
                _context3.next = 7;
                return ApiService.virtualDeviceDrivers.fetch({
                  fields: 'id,title',
                  offset: this.deviceDriversData.currentPage,
                  limit: DRIVER_PAGE_SIZE,
                  search: this.deviceDriversData.searchTerm
                });

              case 7:
                moreDrivers = _context3.sent;
                this.deviceDriversData.currentPage += DRIVER_PAGE_SIZE;
                this.deviceDriversData.deviceDrivers = [].concat(_toConsumableArray(this.deviceDriversData.deviceDrivers), _toConsumableArray(moreDrivers.deviceDrivers));

                if (this.deviceDriversData.deviceDrivers.length >= moreDrivers.totalCount) {
                  this.deviceDriversData.driversHasNextPage = false;
                }

                _context3.next = 17;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](2);
                console.error(_context3.t0);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.wizard.fetchDriverError'), 'error');

              case 17:
                _context3.prev = 17;
                this.deviceDriversData.isLoading = false;
                return _context3.finish(17);

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 13, 17, 20]]);
      }));

      function fetchNextDrivers() {
        return _fetchNextDrivers.apply(this, arguments);
      }

      return fetchNextDrivers;
    }(),
    fetchBridges: function fetchBridges() {
      var _this5 = this;

      this.selectedBridge = null;
      this.deviceBridgesForAccount = [];

      if (!this.template || !this.template.tenantId) {
        return;
      }

      this.deviceBridgesLoading = true;
      Promise.all([ApiService.getBridgeTypes().then(function (bridgeTypes) {
        return bridgeTypes.filter(function (type) {
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
        });
      }), ApiService.getBridgesForTenant(this.template.tenantId)]).then(function (results) {
        _this5.bridgeTypes = results[0];
        var validDeviceBridges = results[1].filter(function (bridgeInstance) {
          var bridgeTypeDef = results[0].find(function (bridgeDef) {
            return bridgeDef.type === bridgeInstance.type;
          });

          if (get(bridgeTypeDef, 'manifest.functionScope.extension.devices.create') || get(bridgeTypeDef, 'manifest.functionScope.extension.devices.read')) {
            return true;
          }

          return false;
        });
        _this5.deviceBridgesForAccount = validDeviceBridges;
        _this5.deviceBridgesLoading = false;
      }).catch(function (error) {
        _this5.deviceBridgesLoading = false;

        _this5.$snack(_this5.$i18n_t('Connectors.Connectors.errors.connectionError'), 'error');

        console.error('Error fetching bridges', error);
      });
    },
    bridgeConfig: function bridgeConfig(bridge) {
      if (!bridge) {
        return;
      }

      var foundMatch = this.bridgeTypes.find(function (config) {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    fetchTenantById: function fetchTenantById() {
      var _this6 = this;

      return ApiService.tenantGetById(this.template.tenantId, ['no-scope-descendents']).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(tenant) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  _this6.accountName = tenant.name;
                  _context4.next = 4;
                  return _this6.getTemplatesLimit();

                case 4:
                  _context4.next = 9;
                  break;

                case 6:
                  _context4.prev = 6;
                  _context4.t0 = _context4["catch"](0);
                  console.error('Error getting template limit', _context4.t0);

                case 9:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[0, 6]]);
        }));

        return function (_x6) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.error('Error fetching tenant', error);
      });
    },
    getTemplatesLimit: function () {
      var _getTemplatesLimit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var templatesLimit, accountTemplates;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return ApiService.getTemplatesLimit(this.template.tenantId);

              case 2:
                templatesLimit = _context5.sent;
                _context5.next = 5;
                return ApiService.deviceTemplatesFetch({
                  page: 1,
                  pageSize: 1,
                  sortDesc: true,
                  tenantIds: [this.template.tenantId]
                });

              case 5:
                accountTemplates = _context5.sent;
                this.deviceTemplatesTotalCount = accountTemplates.pagination['total-count'];
                this.deviceTemplatesLimit = get(templatesLimit, 'data.templatesLimit.templateLimit');

                if (parseInt(this.deviceTemplatesTotalCount) >= parseInt(this.deviceTemplatesLimit)) {
                  this.deviceTemplateLimitExceeded = true;
                }

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getTemplatesLimit() {
        return _getTemplatesLimit.apply(this, arguments);
      }

      return getTemplatesLimit;
    }()
  }
};